import Dialog from "@stimulus-components/dialog";

export default class extends Dialog {
  connect() {
    super.connect()
  }

  open(event) {
    super.open(event)

    // Dispatch an event when dialog opens
    if (this.dialogTarget) {
      // Use setTimeout to ensure the dialog is fully rendered and visible
      setTimeout(() => {
        const openEvent = new CustomEvent('dialog:opened', {
          bubbles: true,
          detail: { controller: this }
        })
        this.dialogTarget.dispatchEvent(openEvent)
      }, 100)
    }
  }

  // static targets = ["dialog"];
  backdropClose(event) {
    //   if (this.hasDialogTarget && event.target === this.dialogTarget) {
    //     this.close();
    //     this.dispatch("backdropClose");
    //   }
  }
}
